import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  workflowUploadService: [
    'runtimeConstant',
    '$filter',
    'webApiSettings',
    'FileUploader',
    'authService',
    function (
      runtimeConstant,
      $filter,
      webApiSettings,
      FileUploader,
      authService
    ) {
      var authData = authService.authentication;
      var isauth = authData.token !== null && authData.token !== '';

      function getUploader(extension) {
        var uploadOptions = {
          extension: extension.toLowerCase(),
          queueLimit: 1,
          url: webApiSettings.apiServiceBaseUri + 'revisions/checkin/',
          removeAfterUploading: true,
          headers: {
            Authorization: isauth ? 'Bearer ' + authData.token : '',
          },
        };

        var uploader = new FileUploader(uploadOptions);

        var filter = {
          name: 'extensionFilter',
          fn: function (item /*{File|FileLikeObject}*/) {
            var ext = item.name.slice(item.name.lastIndexOf('.') + 1);
            if (ext === 'p7s') {
              var nameWithoutSign = item.name.slice(
                0,
                item.name.lastIndexOf('.')
              );
              ext =
                nameWithoutSign.slice(nameWithoutSign.lastIndexOf('.') + 1) +
                '.' +
                ext;
            }

            return this.extension === ext.toLowerCase();
          },
        };
        uploader.filters.push(filter);

        uploader.onErrorItem = function (fileItem, response, status, headers) {
          // eslint-disable-next-line no-console
          console.info('onErrorItem', fileItem, response, status, headers);
          fileItem.isError = true;
          fileItem.isUploaded = false;
        };

        uploader.onWhenAddingFileFailed = function (item, filter) {
          if (filter.name === 'extensionFilter') {
            var msg = $filter('translate')('INVALID FILE FORMAT MESSAGE');
            msg = String.format(msg, [this.extension.toUpperCase()]);
            swal.fire({
              title: $filter('translate')('INVALID FILE FORMAT TITLE'),
              text: msg,
              icon: 'warning',
              confirmButtonColor: 'red',
            });
          }
        };

        return uploader;
      }

      function run() {
        try {
          var uploadServiceFactory = {};

          uploadServiceFactory.getUploader = logWrapper(
            getUploader,
            runtimeConstant.isDebugServicesInternals
          );

          return uploadServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
